import { getAssetUrl } from '@/utils/common';

export const characterPoints = [
  {
    name: '张岱',
    info: {
      label: '张岱文学路线',
      top: -80,
      left: -90,
      down: {
        top: 45,
        left: 150,
      }
    },
    sign: {
      top: 656,
      left: 384,
    },
    width: 155,
    video: getAssetUrl('videos/character/张岱.webm'),
    left: 404,
    top: 586,
    coverPos: {
      top: 704,
      left: 953
    }
  },
  {
    name: '李叔同',
    info: {
      label: '李叔同文学路线',
      top: -70,
      left: -90,
      down: {
        top: 45,
        left: 160,
      }
    },
    sign: {
      top: 861,
      left: 553,
    },
    width: 155,
    video: getAssetUrl('videos/character/李叔同.webm'),
    left: 582,
    top: 807,
    coverPos: {
      top: 807,
      left: 462
    }
  },
  {
    name: '巴金',
    info: {
      label: '巴金文学路线',
      top: -70,
      left: 60,
      down: {
        top: 45,
        left: 20,
      }
    },
    sign: {
      top: 846,
      left: 851,
    },
    width: 150,
    video: getAssetUrl('videos/character/巴金.webm'),
    left: 703,
    top: 810,
    coverPos: {
      top: 810,
      left: 923
    }
  },
  {
    name: '鲁迅',
    info: {
      label: '鲁迅文学路线',
      top: -70,
      left: -80,
      down: {
        top: 45,
        left: 140,
      }
    },
    sign: {
      top: 693,
      left: 1292,
    },
    width: 150,
    video: getAssetUrl('videos/character/鲁迅.webm'),
    left: 1153,
    top: 643,
    coverPos: {
      top: 643,
      left: 1003
    }
  },
  {
    name: '郁达夫',
    info: {
      label: '郁达夫文学路线',
      top: -70,
      left: -100,
      down: {
        top: 45,
        left: 144,
      }
    },
    sign: {
      top: 378,
      left: 1382,
    },
    width: 122,
    video: getAssetUrl('videos/character/郁达夫.webm'),
    left: 1400,
    top: 340,
    coverPos: {
      top: 340,
      left: 1240
    }
  },
  {
    name: '冯雪峰',
    info: {
      label: '冯雪峰文学路线',
      top: -70,
      left: -120,
      down: {
        top: 45,
        left: 150,
      }
    },
    sign: {
      top: 378,
      left: 1590,
    },
    width: 85,
    height: 214,
    image: getAssetUrl('images/route/characterImgs/冯雪峰.png'),
    left: 1632,
    top: 360,
    coverPos: {
      top: 360,
      left: 1972
    }
  },
  {
    name: '马一浮',
    info: {
      label: '马一浮文学路线',
      top: 220,
      left: -100,
      up: {
        top: -15,
        left: 150,
      }
    },
    sign: {
      top: 378,
      left: 1720,
    },
    width: 122,
    video: getAssetUrl('videos/character/马一浮.webm'),
    left: 1736,
    top: 366,
    coverPos: {
      top: 346,
      left: 1436
    }
  },
  {
    name: '林逋',
    info: {
      label: '林逋文学路线',
      top: -60,
      left: 30,
      down: {
        top: 45,
        left: 34,
      }
    },
    sign: {
      top: 378,
      left: 1868,
    },
    width: 133,
    video: getAssetUrl('videos/character/林逋.webm'),
    left: 1880,
    top: 356,
    coverPos: {
      top: 356,
      left: 1590
    }
  },
  {
    name: '王旭烽',
    info: {
      label: '王旭烽文学路线',
      top: -70,
      left: -30,
      down: {
        top: 45,
        left: 80,
      }
    },
    sign: {
      top: 365,
      left: 2231,
    },
    width: 114,
    video: getAssetUrl('videos/character/王旭烽.webm'),
    left: 2137,
    top: 360,
    coverPos: {
      top: 360,
      left: 2350
    }
  },
  {
    name: '范仲淹',
    info: {
      label: '范仲淹文学路线',
      top: -70,
      left: -60,
      down: {
        top: 45,
        left: 140,
      }
    },
    sign: {
      top: 782,
      left: 1985,
    },
    width: 134,
    video: getAssetUrl('videos/character/范仲淹.webm'),
    left: 1851,
    top: 725,
    coverPos: {
      top: 725,
      left: 1851
    }
  },
  {
    name: '苏轼',
    info: {
      label: '苏轼文学路线',
      top: -60,
      left: 40,
      down: {
        top: 45,
        left: 40,
      }
    },
    sign: {
      top: 1060,
      left: 2214,
    },
    width: 176,
    video: getAssetUrl('videos/character/苏轼.webm'),
    left: 2206,
    top: 1035,
    coverPos: {
      top: 1035,
      left: 2206
    }
  },
  {
    name: '钱镠',
    info: {
      label: '钱镠文学路线',
      top: -60,
      left: -100,
      down: {
        top: 45,
        left: 160,
      }
    },
    sign: {
      top: 608,
      left: 2427,
    },
    width: 137,
    video: getAssetUrl('videos/character/钱镠.webm'),
    left: 2444,
    top: 516,
    coverPos: {
      left: 2344,
      top: 516
    }
  },
  {
    name: '白居易',
    info: {
      label: '白居易文学路线',
      top: -60,
      left: -30,
      down: {
        top: 45,
        left: 110,
      }
    },
    sign: {
      top: 872,
      left: 2653,
    },
    width: 146,
    video: getAssetUrl('videos/character/白居易.webm'),
    left: 2519,
    top: 815,
    coverPos: {
      top: 815,
      left: 2319
    }
  },
  {
    name: '岳飞',
    info: {
      label: '岳飞文学路线',
      top: -70,
      left: -100,
      down: {
        top: 45,
        left: 150,
      }
    },
    sign: {
      top: 336,
      left: 2580,
    },
    width: 128,
    video: getAssetUrl('videos/character/岳飞.webm'),
    left: 2616,
    top: 311,
    coverPos: {
      top: 311,
      left: 2506
    }
  },
  {
    name: '于谦',
    info: {
      label: '于谦文学路线',
      top: -40,
      left: 40,
      down: {
        top: 45,
        left: 40,
      }
    },
    sign: {
      top: 637,
      left: 2835,
    },
    width: 176,
    video: getAssetUrl('videos/character/于谦.webm'),
    left: 2691,
    top: 580,
    coverPos: {
      top: 580,
      left: 2391
    }
  },
  {
    name: '陆游',
    info: {
      label: '陆游文学路线',
      top: -70,
      left: 0,
      down: {
        top: 45,
        left: 60,
      }
    },
    sign: {
      top: 397,
      left: 2865,
    },
    width: 112,
    video: getAssetUrl('videos/character/陆游.webm'),
    left: 2739,
    top: 338,
    coverPos: {
      top: 338,
      left: 2680
    }
  },
];

